{
  "deselectedItem": "未選取「{item}」。",
  "select": "選取",
  "selectedAll": "已選取所有項目。",
  "selectedCount": "{count, plural, =0 {未選取任何項目} one {已選取 # 個項目} other {已選取 # 個項目}}。",
  "selectedItem": "已選取「{item}」。"
}
